import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { X } from "lucide-react";
import { resolveImageUrl } from "@/utils/imageUrl";
import { ClubSelectField } from "./ClubSelectField";

export function GalleryForm({ formData, f, managedClubs, api }) {
  const handleMultiUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    f("_uploading", true);
    const newUrls = [...(formData.image_urls || [])];
    let uploaded = 0;
    for (const file of files) {
      f("_uploadProgress", `${uploaded + 1}/${files.length}`);
      const data = new FormData();
      data.append("file", file);
      try {
        const res = await api.upload("/upload", data);
        if (res.data?.url) {
          newUrls.push(res.data.url);
          uploaded++;
        } else {
          toast.error(`Upload ohne URL: ${file.name}`);
        }
      } catch (err) {
        const detail = err.response?.data?.detail || err.message || "";
        toast.error(`Fehler: ${file.name} - ${detail}`);
      }
    }
    f("image_urls", newUrls);
    f("_uploading", false);
    f("_uploadProgress", null);
    if (uploaded > 0) toast.success(`${uploaded} Bild${uploaded > 1 ? 'er' : ''} hochgeladen`);
    e.target.value = "";
  };

  const images = formData.image_urls || [];

  return (
    <>
      <ClubSelectField formData={formData} f={f} managedClubs={managedClubs} />
      <div><Label className="text-sm">Galerie-Titel (gilt für alle Bilder)</Label><Input value={formData.title || ""} onChange={e => f("title", e.target.value)} className="mt-1 bg-input/50 border-white/10 rounded-none" data-testid="dialog-title" placeholder="z.B. DSV Trainingsabend" /></div>
      <div>
        <Label className="text-sm">Bilder hochladen (mehrere gleichzeitig möglich)</Label>
        <div className="mt-2 flex flex-wrap gap-2">
          {images.map((url, idx) => (
            <div key={`gallery-img-${url}-${idx}`} className="relative inline-block">
              <img src={resolveImageUrl(url)} alt="" className="h-20 w-20 object-cover border border-white/10" />
              <button type="button" onClick={() => {
                const updated = [...images];
                updated.splice(idx, 1);
                f("image_urls", updated);
              }} className="absolute -top-1 -right-1 p-0.5 bg-destructive rounded-full" data-testid={`remove-gallery-img-${idx}`}>
                <X className="w-3 h-3 text-white" />
              </button>
            </div>
          ))}
          {formData._uploading && (
            <div className="h-20 w-20 border border-white/10 flex items-center justify-center">
              <span className="text-xs text-muted-foreground animate-pulse">{formData._uploadProgress || "..."}</span>
            </div>
          )}
        </div>
        <input type="file" accept="image/*" multiple onChange={handleMultiUpload} data-testid="dialog-gallery-upload"
          className="mt-2 block w-full text-sm text-muted-foreground file:mr-3 file:py-1.5 file:px-3 file:border-0 file:bg-primary file:text-primary-foreground file:text-xs file:font-bold file:uppercase file:cursor-pointer" />
        {images.length > 0 && (
          <p className="text-xs text-muted-foreground mt-1">{images.length} Bild{images.length !== 1 ? 'er' : ''} ausgewählt</p>
        )}
      </div>
      <div><Label className="text-sm">Beschreibung / Caption (optional, gilt für alle Bilder)</Label><Textarea value={formData.description || ""} onChange={e => f("description", e.target.value)} className="mt-1 bg-input/50 border-white/10 rounded-none" placeholder="Gemeinsame Beschreibung für alle Bilder..." /></div>
    </>
  );
}
